module.exports = __webpack_public_path__ + "img/logo_fqm_branco.12f8d545.svg";